<template>
    <div class="fzmOrderCheckout fzmOrderSchedule">

        <div class="orderCheckoutBody">
            <div class="container">
                <b-row>
                    <b-col lg="5">
                        <div class="banner">
                            <img  src="@/assets/img/orderSummaryImage.png" alt="" />
                        </div>
                    </b-col>

                    <b-col lg="5" offset-lg="1">
                         <button 
                            @click="backbtn"
                            class="btn btn-primary backbtn">Back</button>

                        <div class="orderCheckoutHeader">
                            <div class="row">
                                <div class="col-6">
                                    <h1>Schedule</h1>
                                </div>

                                <div class="col-6">
                                    <button 
                                        :disabled="disablepurchasebtn"
                                        @click="submitorder"
                                        class="btn btn-primary btn-right">

                                        <template v-if="updating">
                                            Update
                                        </template>
                                        <template v-else>
                                            Purchase
                                        </template>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="paymentDetailsBody">
                            <template v-if="$route.name == 'orderschedule'">
                                <div class="paymentOrderBoxes">
                                    <h3>DELIVERY DAY (REPEATS WEEKLY)</h3>
                                    
                                    <div class="schecduleDates">

                                        <template v-for="(day, index) in weekdays">
                                            <div 
                                                @click="selectedday = day.format(), setflagboxchange('date')"
                                                :key="index"
                                                :class="['schedDateItem', isactivedate(day)]">
                                                <div class="schedDay">
                                                    {{day | getday}}
                                                </div>
                                                <div class="schedDate">
                                                    {{day | getdate}}
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <div class="paymentOrderBoxes">
                                <h3>DAY OF EVENT</h3>

                                <div class="scheduleDateDPSelection">
                                    <div class="schedDayItem">
                                        <b-dropdown >
                                            <template #button-content>
                                                {{selectedday | formatdate('MM/DD/YYYY')}} <b-icon icon="chevron-down"></b-icon>
                                            </template>

                                            <b-dropdown-form>
                                                <div class="datepicker-container datepicker-dropdown datepicker-top-left">
                                                    <datepicker 
                                                        :disabled-dates="disabledates"
                                                        v-model="selectedday" 
                                                        :inline="true">
                                                    </datepicker>
                                                </div>
                                            </b-dropdown-form>

                                        </b-dropdown>


                                        <!-- <div class="dropdown type2">
                                        <button data-toggle="datepicker" class="btn btn-outline-primary dropdown-toggle"  type="button" id="dropdownMenuButton1" aria-expanded="false">
                                            Select Day
                                        </button>
                                    </div> -->
                                    </div>

                                    <!-- <div class="schedDayItem">
                                        -
                                    </div> -->

                                    <div class="schedDayItem timeSelection">
                                        <b-dropdown class="type2">
                                            <template #button-content>
                                               {{eventdeliverytime ? eventdeliverytime : 'Select Time Range'}} <b-icon icon="chevron-down"></b-icon>
                                            </template> 

                                            <template v-for="time in timeSelection">
                                                <b-dropdown-item-button @click="eventdeliverytime = time.label" :key="time.value">
                                                    {{time.label}}
                                                </b-dropdown-item-button>
                                            </template>

                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                            </template>

                            <div 
                                v-if="!updating"
                                class="paymentCardDetail">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label>CONTACT NAME</label>

                                        <input
                                            v-model="orderform.contact_name"
                                            type="text"
                                            placeholder="Contact Name"
                                            class="form-control"
                                        />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label>PHONE NUMBER</label>

                                        <input
                                            v-model="orderform.phone_number"
                                            type="text"
                                            placeholder="Phone Number"
                                            class="form-control"
                                        />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label for="">DELIVERY ADDRESS</label>
                                        <div class="row">
                                            <div class="col-12">
                                                <input
                                                    id="autocompletesbox"
                                                    v-model="orderform.shipping_address_street"
                                                    type="text"
                                                    placeholder="Street Address"
                                                    class="form-control"
                                                />
                                            </div>

                                            <div class="col-6">
                                                <input
                                                    readonly
                                                    v-model="orderform.shipping_address_city"
                                                    type="text"
                                                    placeholder="City"
                                                    class="form-control"
                                                />
                                            </div>

                                            <div class="col-3">
                                                <input
                                                    readonly
                                                    v-model="orderform.shipping_address_state"
                                                    type="text"
                                                    placeholder="State"
                                                    class="form-control"
                                                />
                                            </div>

                                            <div class="col-3">
                                                <input
                                                    readonly
                                                    v-model="orderform.shipping_address_zipcode"
                                                    type="text"
                                                    placeholder="Zip"
                                                    class="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <label for="">NOTES</label>

                                        <textarea
                                            v-model="orderform.order_notes"
                                            placeholder="Write a note."
                                            cols="30"
                                            rows="5"
                                            class="form-control"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>


        <b-modal id="submiterror" hide-header hide-footer>
           
            <div class="d-block text-center">
                <div class="cardicon">
                    <b-icon icon="credit-card-fill"></b-icon>
                </div>

                <h3>Your card has been declined.</h3>
                <p>Please return to payment page and update your credit card.</p>
            </div>
            <b-button class="btn btn-primary" block @click="$bvModal.hide('submiterror')">Continue</b-button>
        </b-modal>
        
          <b-modal id="notallowedtoupdate"
            centered
            hide-header
            hide-footer>

            <div class="text-center">
                <img src="@/assets/img/cancelOrder.png" alt="">

                <h3>Cannot Update</h3>
                <p>You cannot update your order on the same day of delivery.</p>

                <b-btn 
                    @click="$bvModal.hide('notallowedtoupdate')"
                    variant="primary" 
                    block>Continue</b-btn>
            </div>

        </b-modal>
    </div>
</template>

<script>
// components

// plugins
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import axios from 'axios';

// Mixins
import {gmapmixins} from '@/mixins/gmapmixins'

// Helpers
import {newJob} from '@/helpers/localbase'
import Helper from '@/helpers/helper'

// mixins 
import {ordermixins} from '@/mixins/ordermixins'

export default {
    mixins : [gmapmixins, ordermixins],
    components: {
        Datepicker,
    },
    computed : {
        /**
         * Check if updating subscription
         */
        updating(){
            return this.$route.name == 'orderschedule' ? this.$route.params.edit : false
        },
        /**
         * Socket io / webshook connection
         */
        socketio() {
            return this.$store.state.socketio
        },
        /**
         * Admin settings
         */
        settings() {
            return this.$store.state.settings  
        },
        /**
         * Minimum order
         */
        minorder() {
            /**
             * Min order for event
             */
            if(this.$route.name == 'ordereventschedule') {
                const minsetting = this.settings.find(sett => sett.settings_field.match(/event_minimum/g))
                return minsetting ? parseInt(minsetting.settings_value) : 0
            } else {
                /**
                 * Min order for subscription
                 */
                const minsetting = this.settings.find(sett => sett.settings_field.match(/subscription_minimum/g))
                return minsetting ? parseInt(minsetting.settings_value) : 0
            }
        },
        /**
         * Card details generated from card connect api
         */
        carddetails() {
            return this.$store.state.cardconnectdetails
        },
         /**
         * User subscription data
         */
        subscription () {
            const [sub] = this.$store.state.subscriptions
            return sub ? sub : null
        } ,
        /**
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        },
        /**
         * Logged in user data
         */
        user() {
            return this.$store.state.user
        },
        /**
         * Check if all parameters are valid 
         * Enable diable purchase button
         */
        disablepurchasebtn() {
            let   notvalid = false
            const order    = this.orderform
            
            if(order.box_items.length < this.minorder) {
                notvalid = true
            } else if(!order.billing_address_latitude) {
                notvalid = true
            } else if(!order.billing_address_longitude) {
                notvalid = true
            } else if(!order.phone_number) {
                notvalid = true
            } else if(!order.delivery_day) {
                notvalid = true
            }  else if (!this.selectedday) {
                notvalid = true
            }
            
            if(order.card_payment == "new_card") {
                if(!order.card_token) {
                    notvalid = true
                } 
            }
            
            
            if(this.$route.name == 'ordereventschedule' && !this.eventdeliverytime) {
                notvalid = true
            }

            /**
             * Override 
             * check if updating
             */
            if(this.updating) {
                notvalid = false
            }

            if(this.isprocessing) {
                notvalid = true
            }



            return notvalid;
        }
    },  
    filters : {
        /**
         * Format date by
         * @param {String} format @example MM-DD-YYYY
         */
        formatdate(date, format) {
            return date ? moment(date).format(format) : '';
        },
        /**
         * Format date by day
         */
        getday(date) {
            return date ? moment(date).format('ddd')  : '';
        },
        /**
         * Format date by date
         */
        getdate(date) {
            return date ? moment(date).format('DD'): '';
        }
    },
    data() {
        return {
            /**
             * Selected day order will repeat
             */
            selectedday:  null,
            /**
             * Processing state
             * if true purchase button should be disabled
             */
            isprocessing : false,
            /**
             * Date picker configs
             */
            disabledates : {
                // to  : new Date(Helper.formatdate(moment().startOf('day'), 'MM/DD/YYYY')),
                to  : new Date(Helper.formatdate(moment().add(1, 'day').startOf('day'), 'MM/DD/YYYY')),
                days: [0]
            },
            /**
             * Order for event Deliery  time selection
             * date will be inselectedday computed state
             */
            eventdeliverytime : '',
            /**
             * Time selection is for order for event
             * Start time will be at 9am and end on 8pm with 1 hour increment 
             */
            timeSelection : [
                {
                    label: '9:00 AM - 10:00 AM',
                    value: '9:00 AM'
                },
                {
                    label: '10:00 AM - 11:00 AM',
                    value: '10:00 AM'
                },
                {
                    label: '11:00 AM - 12:00 PM',
                    value: '11:00 AM'
                },
                {
                    label: '12:00 PM - 1:00 PM',
                    value: '12:00 PM'
                },
                {
                    label: '1:00 PM - 2:00 PM',
                    value: '1:00 PM'
                },
                {
                    label: '2:00 PM - 3:00 PM',
                    value: '2:00 PM'
                },
                {
                    label: '3:00 PM - 4:00 PM',
                    value: '3:00 PM'
                },
                {
                    label: '4:00 PM - 5:00 PM',
                    value: '4:00 PM'
                },
                {
                    label: '5:00 PM - 6:00 PM',
                    value: '5:00 PM'
                },
                {
                    label: '6:00 PM - 7:00 PM',
                    value: '6:00 PM'
                },
                {
                    label: '7:00 PM - 8:00 PM',
                    value: '7:00 PM'
                },
              
            ],
            /**
             * Order form
             * All details from previous screens will be assigned here as paramenter for creating order
             * Contact details by default loggedin user details will be in pulled
             * Object properties must be defined for reactivity
             */
            orderform : {
                box_items                 : [],
                shipping_address_street   : "",
                shipping_address_city     : "",
                shipping_address_state    : "UT",
                shipping_address_zipcode  : "",
                shipping_address_latitude : "",
                shipping_address_longitude: "",
                card_token                : "",
                contact_name              : "",
                phone_number              : "",
                delivery_day              : "",
                card_name                 : "",
                card_expiry               : '',
                card_last_four_digit      : '',
                card_payment              : 'new_card',
                event_time_range    : '',
                order_notes               : ''
            }
        }
    },
    methods : {
        /**
         * Back button
         * check if updating 
         */
        backbtn( ){
            if(this.updating) {
                this.$router.push({name : 'editsubscription'})

            } else {
                this.$router.push({name : 'payment'})
            }
        },
        /**
         * changing shipping date
         * don't proceed if skipping dates are present
         */
        async changeshippingdate() {

            const sub = this.subscription

            /**
             * Check if skipping and ignore changes to delivery date
             * also check if the change is now same date
             */ 
            const nextdate    = moment(this.selectedday).utc()
            const currentdate = moment(sub.next_shipment_at).utc()
            const params      = {next_shipping_date : nextdate.format('YYYY-MM-DD')}

            if(!nextdate.isSame(currentdate, 'day')) {
                const url = `/update_next_shipping_date/${sub.id}`
                const res = await axios.post(url, params).catch(err => console.log(err))
                if(res.data.success) {
                    this.$store.dispatch('getSubscriptions')
                } else if(!this.isonline) {
                    /**
                     * If offline add request to job
                     */
                    newJob({
                        url : url,
                        method : "POST",
                        params : params,
                        callback : (data, options) => {
                            /**
                             * Check if success and call get subscription 
                             */
                            if(data.success) {
                                options.store.dispatch('getSubscriptions')
                            }
                        }
                    })
                }
            }
        },
        /**
         * Update subscription box items
         * update indexeddb
         * and send api request 
         */
        async updatesubitembox() {
            const sub = this.subscription;

            if(sub) {
                 /**
                 * Check if subscription delivery date is same as today.
                 * if same don't proceed
                 */
                if(moment(sub.next_shipment_at).utc().endOf('day').isSame(moment(), 'day')) {
                    this.$bvModal.show('notallowedtoupdate');
                    return;
                }

                const url = `/subscriptions/${sub.id}`;
                const params  = {
                    box_items : this.orderboxes.map(order => {
                                    return {
                                        id      : order.id,
                                        box_name: order.box_name,
                                        flavors : order.flavors,
                                        price   : 0
                                    }
                                })
                    }

                const res = await axios.put(url, params).catch(err => console.log(err))

                /**
                 * If success update indexeddb
                 * add subscription id  as one of the property as identity
                 */
                if(res.data.success) {
                    this.$store.dispatch('getsubboxitems', sub.id)
                   
                } else if(!this.isonline) {
                    /**
                     * If offline add request to job
                     */
                    newJob({
                        url     : url,
                        method  : "PUT",
                        params  : params,
                        callback: (data, options) => {
                            /**
                             * Check if success
                             * then update indexed db
                             */

                             /**
                             * Re-stracture data
                             * check ordermixins.js newboxproperty function for properties we need 
                             * (type) this property will be remove in future so avoid using it
                             * (price) this property will be remove in future so avoid using it
                             * (flavors) this property will be the id's of the flavor
                             * (flavorfull) this property will have full data properties of the flavor
                             */
                            const restracture = (dataobj, group_id) => {
                                return {
                                    id         : dataobj.box_id,
                                    box_name   : dataobj.box_name,
                                    type       : dataobj.box_id,
                                    flavors    : dataobj.flavors.map(f => f.id),
                                    flavorsfull: dataobj.flavors,
                                    price      : 0,
                                    sub_id     : sub.id,
                                    group_id   : group_id
                                }
                            }

                            if(data.success) {
                                const newdata = data.data.map((item, index) => restracture(item, index));

                                for (let index = 0; index < newdata.length; index++) {
                                    const item = newdata[index];

                                    options.db.addUpdateCollection({name : 'boxitems', filter: {id : item.id}, data : item})
                                    
                                }
                            }
                        }
                    })
                }

            }
        },
        /**
         * Submit function
         * check what type of order and call corresponding function
         */
        async submitorder() {
            this.isprocessing = true;

            /**
             * Check if for update
             */
            if(this.updating) {
                const flag = this.$store.state.editsubscriptionflags

                if(flag.boxchanges && flag.datechanges) {
                    this.changeshippingdate();
                    this.updatesubitembox();
                } else if(flag.boxchanges) {
                    this.updatesubitembox();
                } else if(flag.datechanges) {
                    this.changeshippingdate();
                }

                this.setflagboxchange('reset');

                 /**
                 * Redirect to account profile
                */
                this.$router.push({name : "ordersubscription"})

                return;
            }

            if(this.$route.name == 'ordereventschedule') {
                await this.ordernow();
            } else {
                await this.subscribe();
            }

            this.isprocessing = false;

            /**
             * Broadcast new order placed
             */
            if(this.socketio) {
                this.socketio.emit('broadcast', {
                    type : 'neworder'
                })
            }
        },
        /**
         * Order now function
         * Submitting order for event
         */
        async ordernow() {
            const url    = '/orders';
            let   params = this.orderform;
            
            /**
             * Check if existing 
             * then delete
             * card_token
             * card_name
             * card_last_four_digit
             * card_expiry
             */
            if(params.card_payment == 'existing_card') {
                delete params.card_token
                delete params.card_name
                delete params.card_last_four_digit
                delete params.card_expiry
            }

            /**
             * Format schedule date
             */
            params.delivery_day           = moment(this.selectedday).format('YYYY-MM-DD');
            params.event_time_range = this.eventdeliverytime;

            
            await axios.post(url, params).then(res => {
                if(res.data.success) {
                    this.$router.push({name : 'thankyou', params : {date : params.delivery_day, time : this.eventdeliverytime}})
                }
            }).catch(() => {
                /**
                 * If error register to job for calling it multiple times before terminating
                 * 
                 */

                if(!this.isonline) {
                    newJob({
                        url     : url,
                        params  : params,
                        method  : 'POST',
                        callback: (data, options) => {
                            /**
                             * If job sucess page will redirect to thankyou page
                             */
                            if(data.success) {
                                options.router.push({name : 'thankyou', params : {date : data.job.params.delivery_day, time : data.job.params.event_time_range}});
                            }
                        }
                    });
                } else {
                    /**
                     * Show error modal
                     */
                    this.$bvModal.show('submiterror');
                }
            })
        },
        /**
         * Submit subscription
         * this will be called only if user doesn't have subscription because 
         * 1 subscription per user only
         */
        async subscribe() {
            const url    = '/subscriptions';
            let params = this.orderform;

            /**
             * Check if existing 
             * then delete
             * card_token
             * card_name
             * card_last_four_digit
             * card_expiry
             */
            if(params.card_payment == 'existing_card') {
                delete params.card_token
                delete params.card_name
                delete params.card_last_four_digit
                delete params.card_expiry
            }
            /**
             * Format schedule date
             */
            params.delivery_day = moment(this.selectedday).format('YYYY-MM-DD');


            /** Check if has subscription add put method */
            if(this.subscription) {
                params._method = 'PUT';
            }

            await axios({
                method: 'POST',
                url   : url,
                data  : params
            }).then(res => {
                if(res.data.success) {
                    this.$store.dispatch('getSubscriptions')
                    this.$router.push({name : 'thankyou', params : {date : params.delivery_day, time : this.eventdeliverytime}})
                }
            }).catch(() => {
                /**
                 * If error register to job for calling it multiple times before terminating
                 * 
                 */

                if(!this.isonline) {
                    newJob({
                        url     : url,
                        params  : params,
                        method  : "POST",
                        callback: (data, options) => {
                            /**
                             * If job sucess page will redirect to thankyou page
                             */
                            if(data.success) {
                                options.router.push({name : 'thankyou', params : {date : params.delivery_day, time : ''}});
                            }
                        }
                    });
                } else {
                    /**
                     * Show error modal
                     */
                    this.$bvModal.show('submiterror');
                }
            })
        },
        /**
         * autocomplete place will query from google map api to get address suggestion.
         * @param {DOM} inputbox input box where the autocomplete will trigger
         */
        autocompleteaddress() {
            const inputbox = document.getElementById('autocompletesbox');

            if(inputbox) {
                /**
                 * Callback
                 * Process return data from autocomplete address
                 */
                const callback = (data) => {
                   this.$nextTick(() => {

                       console.log('auto fill', data)
                        /**
                         * get latitude and longtitude
                         */
                        this.orderform.shipping_address_latitude  = data.geometry.location.lat();
                        this.orderform.shipping_address_longitude = data.geometry.location.lng();

                        /**
                         * get street, city, state, zipcode
                         */
                        // get street
                        const streetnumber = data.address_components.find(d => d.types.includes('street_number'));
                        const street       = data.address_components.find(d => d.types.includes('street'));
                        const route        = data.address_components.find(d => d.types.includes('route'));
                        
                        this.orderform.shipping_address_street = `${streetnumber ? streetnumber.short_name : ''} ${street ? street.short_name : ''} ${route ? route.long_name : ''}`;
                        
                        // get city
                        const city              = data.address_components.find(d => d.types.includes('locality') || d.types.includes('postal_town'));
                              this.orderform.shipping_address_city = city.long_name;

                         // get state
                        const state                             = data.address_components.find(d => d.types.includes('administrative_area_level_1'));
                              this.orderform.shipping_address_state = state.short_name;


                        // get postal_code
                        const postalcode                       = data.address_components.find(d => d.types.includes('postal_code') || d.types.includes('postal_code_suffix'));
                              this.orderform.shipping_address_zipcode = postalcode.short_name;
                   });

                }

                this.autocompletedress(inputbox, callback);
            }
        },
        /**
         * For subscription parameters
         * Function that will 
         * Get order details and will
         * Get logged in user details as default contact details of the order
         */
        async assembleorderdetails() {

            /**
             * Set default delivery date on order for event
             * and it should be monday to saturday
             */
            const date = this.updating ? moment(this.subscription.next_shipment_at) :  Helper.formatdate(moment().add(1, 'day'), 'MM/DD/YYYY');
            this.selectedday = moment(date).day() != 0 ?  moment(date).format() : moment().add(2, 'days').format() 

            //check if selectedday is sunday then add 1 more day
            if(moment(this.selectedday).day() == 0) {
                this.selectedday = moment(this.selectedday).add(1, 'day')
            }

            

            // Get default contact
            const user  = this.user;
            const order = this.orderform;

            /**
             * Check if has subscription then user shipping address of subscription
             */

            if(user) {
                order.contact_name             = user.name;
                order.phone_number             = user.phone_number;
                order.shipping_address_street  = this.subscription ? this.subscription.order.shipping_address_street : user.address_street;
                order.shipping_address_city    = this.subscription ? this.subscription.order.shipping_address_city : user.address_city;
                order.shipping_address_state   = this.subscription ? this.subscription.order.shipping_address_state : user.address_state;
                order.shipping_address_zipcode = this.subscription ? this.subscription.order.shipping_address_zipcode : user.address_zipcode;
                
                /**
                 * Get address lat and lng
                 */
                const inputbox   = document.getElementById('autocompletesbox');
                const address    = `${user.address_street} ${user.address_city} ${user.address_state} ${user.address_zipcode}`;
                const addressquery = await this.queryPlace(inputbox, address);


                if(addressquery) {
                    const [mapaddress] = addressquery;

                    console.log('address query', mapaddress);

                    order.shipping_address_latitude  = mapaddress.geometry.location.lat();
                    order.shipping_address_longitude = mapaddress.geometry.location.lng();
                }


               
            }


            //Get order details
            const boxitems           = this.$store.state.orderboxes.slice();
                  order.delivery_day = moment(this.selectedday).format('YYYY-MM-DD');
                  order.box_items    = boxitems.map(b => {

                      b.flavors = b.flavors.map(f => f.id ? f.id : f)
                    
                      return b
                  })

            const mergedparams = {
                ...order,
                ...this.carddetails
            }

            this.orderform = mergedparams;
        },
        /**
         * Check if selected day is same with date from the loop
         */
        isactivedate(date) {
            return moment(date).isSame(this.selectedday, 'day') ? 'active' : '';
        }
    },
    /**
     * Beforemount will run function before component render
     */
    beforeMount() {
        //Get week days
        if(this.updating && this.subscription) {
            this.getweekdays(this.subscription.next_shipment_at);
        } else {
            this.getweekdays();
        }
        
       
    },
    /**
     * Mounted will run function after component rendered
     */
    mounted() {

        // initiate address autocomplete
        // Initiate google map 
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
            this.autocompleteaddress(); 
            
            /**
            * Get default contact details 
            * and get other details
            */
            this.assembleorderdetails();
        });
    }
    
};
</script>

<style lang="scss">
@import "@/scss/global/_mixins.scss";
@import "@/scss/_settings.scss";

#submiterror {
    .cardicon {
        font-size : 60px;
        margin-top: 30px;
    }

    
    .btn {
        max-width    : 300px;
        margin-top   : 50px;
        margin-bottom: 30px;
        margin-left  : auto;
        margin-right : auto;
        display      : block;
    }

    h3 {
        margin-top   : 30px;
    }
}

.fzmOrderSchedule {

    .banner {
        @include screen-up(lg) {
            height  : 200px;
            overflow: hidden;
            position: relative;

            img {
                position : absolute;
                top      : 50%;
                transform: translateY(-50%);
            }
        }
    }

    .backbtn {
        @include screen-up(lg) {
            margin-top : 30px;
        }
    }

    .form-control {
        border-color: transparent;
        padding-left: 0;

        &:focus {
            outline   : none;
            box-shadow: none;
        }
    }

    .dropdown {

        &.show {
            .dropdown-toggle {
                background-color: $primary-color;
                color           : white;
            }
        }

        .dropdown-toggle {
            width         : 200px;
            text-align    : left;
            display       : flex;
            padding-top   : 10px;
            padding-bottom: 10px;
            font-size     : 15px;

            &::after {
                display: none;
            }

            @include screen-up(sm) {
                width : 50%;
            }

            svg {
                font-size : 12px;
                margin-left : auto;
                margin-top : 3px;
            }
        }
    }
    
    .scheduleDateDPSelection {
        
        @include screen-up(sm) {
            display: flex;

            .schedDayItem {
                flex : 1;

                &:last-child {
                    margin-right : 0;
                }

                .dropdown {
                    width : 100%;

                    .dropdown-toggle{
                        width : 100%;
                    }
                }
            }
        }

        .btn {
            border-radius: 0 !important;
            border: 1px solid $light-gray;
            
        }

        .dropdown {

            .dropdown-toggle{
                text-transform: none;
            }

            .dropdown-menu {
                overflow: initial;
                border  : none;
            }
        }
    }

    .timeSelection {
        .dropdown {
            .dropdown-menu {
                @include boxShadow;

                overflow: hidden auto;
            }
        }
    }


}
</style>
